import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: "en", // set locale
    fallbackLocale: "en",
    messages: {
        en: {
            //menu
            "menu.home": "Home",
            "menu.about": "About",
            "menu.contact": "Contact",
            "menu.login": "Login",
            "menu.logout": "Logout",
            "menu.register": "Register",
            //Testimonials
            "menu.testimonials": "Testimonials",
            //FAQ
            "menu.faq": "FAQ",
            //Pricing
            "menu.pricing": "Pricing",
            //Changelog
            "menu.log": "Changelog",
            //Downloads
            "menu.downloads": "Downloads",


            //content
            "con.headline": "All-in-one Corporate Secure Access Solution.",
            "con.text": "Cyberfox Guard is a suite of aplications and extensions dedicated to make your company accounts access more secure.",

            "con.headline2": "Tools and Widgets",
            "con.text2": "Made to improve and ease your daily experience.",
            "con.block.title1": "One Click Access",
            "con.block.text1": "Enable or disable access in 1 Click",
            "con.block.title2": "Contacts",
            "con.block.text2": "Easy to use and always at your disposal",
            "con.block.title3": "2FA",
            "con.block.text3": "Included Two Factor Authentification",
            "con.block.title4": "Links List",
            "con.block.text4": "The easy way to store your links",
            "con.block.title5": "iOS and Android",
            "con.block.text5": "iOS and Android with all the required features",
            "con.block.title6": "Clock",
            "con.block.text6": "World clocks, time to go international",


            "con.headline3": "What People are saying",
            "con.text3": "People around the internet love using Cyberfox Guard.",

            "con.test.text1": "Best Extension ever! Have been using it for several months. Couldn't do without it now.",
            "con.test.text2": "Great page to keep your main websites handy. It's way better than searching through bookmarks!",
            "con.test.text3": "Excellent add-on for bookmarks and speed dialing. Indeed a very handy tool!",
            "con.test.text4": "Awesome app ever since it became available I've always used it on all my pc's it's the best at least it works for me. Its my number one go to home page and browser.",
            "con.test.text5": "Absolutely love this, my favorite pages all in one place which makes it easy to perform tasks! Great job guys, I love it!",
            "con.test.text6": "This is a great application. I find it much simpler than organizing bookmarks.",
            "con.test.text7": "Enjoy the app, easy, attractive and a pleasure to use. Simple, does what it says.",
            "con.test.text8": "It's an awesome software. Just love it.",
            "con.test.text9": "Great organizational tool for office!",

            "con.headline4": "Frequently Asked Questions",
            "con.text4": "You have questions, we have answers!",

            "con.faq.question1": "What browsers are supported by Cyberfox Guard?",
            "con.faq.text1": "Cyberfox Guard supports Custom build Chrome for security. Please feel free to contact us for support.",
            "con.faq.question2": "How does Cyberfox Guard protect my data?",
            "con.faq.text2": "Cyberfox Guard uses a combination of encryption and secure protocols to protect your data.",
            "con.faq.question3": "How many accounts I can add to this platform?",
            "con.faq.text3": "There is no limit on how many accounts and passwords you can store and share with your co-workers using CyberFox Guard.",
            "con.faq.question4": "How can I get support?",
            "con.faq.text4": "You can contact us by email at hello@cyberfoxguard.com",


            "con.headline5": "How to get started?",
            "con.text5": "Instalation is easy and fast. Just follow the steps below.",
            
  
            //general
            "misc.more": "and more...",
            "misc.privacy": "Privacy Policy",
            "misc.terms": "Terms of Service",
            "misc.downloads": "Downloads and Installs",
            "misc.extension": "Extension",
            "misc.app": "App",
            "misc.appstore": "App Store",
            "misc.playstore": "Play Store",
            "misc.contact": "Contact Us", 
            
            //contact form
            "con.contact.title": "Contact Us",
            "con.contact.text": "If you have any questions, please feel free to contact us.",
            "con.contact.name": "Name",
            "con.placeholder.name": "Your Name",
            "con.contact.email": "Email",
            "con.placeholder.email": "Your Email",
            "con.contact.phone": "Phone",
            "con.placeholder.phone": "Your Phone",
            "con.contact.message": "Message",
            "con.placeholder.message": "Your Message",
            "con.contact.send": "Send",
            "con.contact.success": "Your message has been sent successfully.",
            "con.contact.error": "There was an error sending your message. Please try again later.",
            //Are you human?
            "con.contact.human": "Are you human?",
            "con.contact.human.error": "Please confirm you are human.",
            "con.contact.human.success": "Thank you for confirming you are human.",

            "con.contact.human.op0": "Select Answer",
            "con.contact.human.op1": "No, I am not!",
            "con.contact.human.op2": "What is a human?",
            "con.contact.human.op3": "I wish I was :)",
            "con.contact.human.op4": "Indeed, I am!",
            "con.contact.human.op5": "Maybe Someday...",
            
            
            //buttons
            "btn.download": "Download",
            "btn.contact": "Contact Sales",
            "btn.learn": "Learn more",
            "btn.close": "Close",
            "btn.open": "Open",
            "btn.cancel": "Cancel",
            "btn.send": "Send",
            "btn.send.another": "Send Another",

            //footer
            "footer.copyright": "Copyright © 2023 CyberFoxGuard. All rights reserved.",
            "footer.privacy": "Privacy Policy",
            "footer.terms": "Terms of Service",


            //Pricing

            "price.subscription": "Subscription",
            "price.monthly": "monthly per user",
            "price.yearly": "yearly per user",

            //  Basic Subscription
           "price.block1.type": "Basic",
           "price.block1.desk": "Basic subscription plan includes all future updates with limited storage space.",
           "price.block1.bull1": "Unlimited Accounts & Passwords",
           "price.block1.bull2": "Limited History & Logs",
           "price.block1.bull3": "Updates (features and widgets)",
           "price.block1.bull4": "Advanced Statistical Data",
           "price.block1.bull5": "Cloud Backup",

            //  Pro Subscription
            "price.block2.type": "Pro",
            "price.block2.desk": "Pro subscription plan includes all features and an increase in your security along with a Pro Extension.",
            "price.block2.bull1": "Unlimited Accounts & Passwords",
            "price.block2.bull2": "Unlimited History & Logs",
            "price.block2.bull3": "Updates (features and widgets)",
            "price.block2.bull4": "Advanced Statistical Data",
            "price.block2.bull5": "Cloud Backup",





            


            
        },
        ro: {
            //menu
            "menu.home": "Acasă",
            "menu.about": "Despre noi",
            "menu.contact": "Contact",
            "menu.login": "Autentificare",
            "menu.logout": "Ieșire",
            "menu.register": "Înregistrare",
            //Testimonials
            "menu.testimonials": "Testimoniale",
            //FAQ
            "menu.faq": "Întrebări frecvente",
            //Pricing
            "menu.pricing": "Prețuri",
            //Changelog
            "menu.log": "Istoric modificări",
            //Downloads
            "menu.downloads": "Descărcări",
            
            
            //content

            "con.headline": "Soluție de acces securizat pentru companii, totul într-un singur loc.",
            "con.text": "Cyberfox Guard este un set de aplicații și extensii dedicate pentru a face accesul la conturile companiei tale mai sigur.",
            "con.headline2": "Instrumente și widget-uri",
            "con.text2": "Creata pentru a îmbunătăți și a ușura experiența ta zilnică.",
            "con.block.title1": "Acces cu un singur clic",
            "con.block.text1": "Activează sau dezactivează accesul cu un singur clic",
            "con.block.title2": "Contacte",
            "con.block.text2": "Ușor de utilizat și întotdeauna la dispoziția ta",
            "con.block.title3": "2FA",
            "con.block.text3": "Autentificare în doi pași inclusă",
            "con.block.title4": "Listă de linkuri",
            "con.block.text4": "Cea mai ușoară modalitate de a-ți stoca linkurile",
            "con.block.title5": "iOS și Android",
            "con.block.text5": "iOS și Android cu toate funcțiile necesare",
            "con.block.title6": "Ceas",
            "con.block.text6": "Ceasuri mondiale, timpul pentru a deveni internațional",
            
            
            
            "con.headline3": "Ce spun oamenii",
            "con.text3": "Oamenii din întreaga lume iubesc să folosească Cyberfox Guard.",
            
            "con.test.text1": "Cea mai bună extensie! O folosesc de câteva luni. Nu aș putea trăi fără ea acum.",
            "con.test.text2": "O pagină excelentă pentru a-ți păstra site-urile preferate la îndemână. E mult mai bine decât să cauți în bookmark-uri!",
            "con.test.text3": "Un add-on excelent pentru bookmark-uri și apeluri rapide. Cu adevărat un instrument foarte util!",
            "con.test.text4": "O aplicație grozavă, de când a devenit disponibilă, am folosit-o întotdeauna pe toate PC-urile mele, este cea mai bună, cel puțin pentru mine. Este pagina mea principală și browserul numărul unu.",
            "con.test.text5": "Îmi place absolut, paginile mele preferate toate într-un singur loc, ceea ce face ușor să îndeplinesc sarcinile! Bravo băieți, îmi place!",
            "con.test.text6": "Această este o aplicație grozavă. O consider mult mai simplă decât organizarea bookmark-urilor.",
            "con.test.text7": "Îmi place aplicația, ușor de utilizat, atractivă și o plăcere să o folosești. Simplu, face ceea ce spune.",
            "con.test.text8": "Este un software grozav. Îmi place foarte mult.",
            "con.test.text9": "Un instrument excelent de organizare pentru birou!",

            "con.headline4": "Întrebări frecvente",
            "con.text4": "Ai întrebări, noi avem răspunsuri!",

            "con.faq.question1": "Ce browsere sunt acceptate de Cyberfox Guard?",
            "con.faq.text1": "Cyberfox Guard acceptă Chrome personalizat pentru securitate. Te rugăm să ne contactezi pentru suport.",
            "con.faq.question2": "Cum protejează Cyberfox Guard datele mele?",
            "con.faq.text2": "Cyberfox Guard folosește o combinație de criptare și protocoale securizate pentru a-ți proteja datele.",
            "con.faq.question3": "Câte conturi pot adăuga pe această platformă?",
            "con.faq.text3": "Nu există limită la câte conturi și parole poți stoca și partaja cu colegii tăi folosind CyberFox Guard.",
            "con.faq.question4": "Cum pot obține suport?",
            "con.faq.text4": "Ne poți contacta prin email la hello@cyberfoxguard.com",


            "con.headline5": "Cum să începi?",
            "con.text5": "Instalarea este ușoară și rapidă. Urmează pașii de mai jos.",



            //general
            "misc.more": "și multe altele...",
            "misc.privacy": "Politica de confidențialitate",
            "misc.terms": "Termeni de utilizare",
            "misc.downloads": "Descărcări și instalări",
            "misc.extension": "Extensie",
            "misc.app": "Aplicație",
            "misc.appstore": "App Store",
            "misc.playstore": "Play Store",
            "misc.contact": "Contactează-ne",

            
            //contact form
            "con.contact.title": "Contactează-ne",
            "con.contact.text": "Dacă ai întrebări, te rugăm să ne contactezi.",
            "con.contact.name": "Nume",
            "con.placeholder.name": "Numele tău",
            "con.contact.email": "Email",
            "con.placeholder.email": "Email-ul tău",
            "con.contact.phone": "Telefon",
            "con.placeholder.phone": "Telefonul tău",
            "con.contact.message": "Mesaj",
            "con.placeholder.message": "Mesajul tău",
            "con.contact.send": "Trimite",
            "con.contact.success": "Mesajul tău a fost trimis cu succes.",
            "con.contact.error": "A apărut o eroare la trimiterea mesajului tău. Te rugăm să încerci din nou mai târziu.",
            //Are you human?
            "con.contact.human": "Ești om?",
            "con.contact.human.error": "Te rugăm să confirmi că ești om.",
            "con.contact.human.success": "Îți mulțumim că ai confirmat că ești om.",

            "con.contact.human.op0": "Selectează răspunsul",
            "con.contact.human.op1": "Nu, nu sunt!",
            "con.contact.human.op2": "Ce este un om?",
            "con.contact.human.op3": "Mi-aș dori să fiu :)",
            "con.contact.human.op4": "De fapt, sunt!",
            "con.contact.human.op5": "Poate într-o zi...",
            

            //buttons
            "btn.download": "Descarcă",
            "btn.contact": "Contactează vânzările",
            "btn.learn": "Află mai multe",
            "btn.close": "Închide",
            "btn.open": "Deschide",
            "btn.cancel": "Anulează",
            "btn.send": "Trimite",
            "btn.send.another": "Trimite altul",


            //footer
            "footer.copyright": "Copyright © 2023 CyberFoxGuard. Toate drepturile rezervate.",
            "footer.privacy": "Politica de confidențialitate",
            "footer.terms": "Termeni de utilizare",


            //Pricing


            "price.subscription": "Abonament",
            "price.monthly": "lunar pe utilizator",
            "price.yearly": "anual pe utilizator",

            //  Basic Subscription
            "price.block1.type": "Basic",
            "price.block1.desk": "Planul de abonament Basic include toate actualizările viitoare cu spațiu de stocare limitat.",
            "price.block1.bull1": "Conturi și parole nelimitate",
            "price.block1.bull2": "Istoric și jurnale limitate",
            "price.block1.bull3": "Actualizări (funcții și widget-uri)",
            "price.block1.bull4": "Date statistice avansate",
            "price.block1.bull5": "Backup în cloud",


            //  Pro Subscription
            "price.block2.type": "Pro",
            "price.block2.desk": "Planul de abonament Pro include toate funcțiile și o creștere a securității tale împreună cu o extensie Pro.",
            "price.block2.bull1": "Conturi și parole nelimitate",
            "price.block2.bull2": "Istoric și jurnale nelimitate",
            "price.block2.bull3": "Actualizări (funcții și widget-uri)",
            "price.block2.bull4": "Date statistice avansate",
            "price.block2.bull5": "Backup în cloud",

        },
        ru: {
            //menu
            "menu.home": "Главная",
            "menu.about": "О нас",
            "menu.contact": "Контакты",
            "menu.login": "Войти",
            "menu.logout": "Выйти",
            "menu.register": "Регистрация",
            //Testimonials
            "menu.testimonials": "Отзывы",
            //FAQ

            "menu.faq": "Часто задаваемые вопросы",
            //Pricing
            "menu.pricing": "Цены",
            //Changelog
            "menu.log": "История изменений",
            //Downloads
            "menu.downloads": "Загрузки",


            //content
            "con.headline": "Все в одном решении для безопасного доступа к корпоративным данным.",
            "con.text": "Cyberfox Guard - это набор приложений и расширений, предназначенных для повышения безопасности доступа к учетным записям вашей компании.",

            "con.headline2": "Инструменты и виджеты",
            "con.text2": "Создано для улучшения и упрощения вашего повседневного опыта.",
            "con.block.title1": "Доступ в один клик",
            "con.block.text1": "Включите или отключите доступ в один клик",
            "con.block.title2": "Контакты",
            "con.block.text2": "Простота использования и всегда под рукой",
            "con.block.title3": "2FA",
            "con.block.text3": "Включена двухфакторная аутентификация",
            "con.block.title4": "Список ссылок",
            "con.block.text4": "Легкий способ сохранить ваши ссылки",
            "con.block.title5": "iOS и Android",
            "con.block.text5": "iOS и Android со всеми необходимыми функциями",
            "con.block.title6": "Часы",
            "con.block.text6": "Мировые часы, время стать международным",


            "con.headline3": "Что говорят люди",
            "con.text3": "Люди по всему миру любят использовать Cyberfox Guard.",

            "con.test.text1": "Лучшее расширение! Я использую его уже несколько месяцев. Теперь не могу без него обойтись.",
            "con.test.text2": "Отличная страница, чтобы держать ваши основные сайты под рукой. Это намного лучше, чем искать в закладках!",
            "con.test.text3": "Отличное дополнение для закладок и быстрого набора. Действительно очень полезный инструмент!",
            "con.test.text4": "Отличное приложение, с тех пор как оно стало доступно, я всегда использовал его на всех своих ПК, это лучшее, по крайней мере для меня. Это моя главная страница и браузер номер один.",
            "con.test.text5": "Мне это абсолютно нравится, мои любимые страницы все в одном месте, что облегчает выполнение задач! Отличная работа, ребята, мне это нравится!",
            "con.test.text6": "Это отличное приложение. Я нахожу его намного проще, чем организовывать закладки.",
            "con.test.text7": "Мне нравится приложение, легко в использовании, привлекательно и приятно использовать. Просто, делает то, что обещает.",
            "con.test.text8": "Это отличное программное обеспечение. Просто люблю это.",
            "con.test.text9": "Отличный инструмент для организации офиса!",


            "con.headline4": "Часто задаваемые вопросы",
            "con.text4": "У вас есть вопросы, у нас есть ответы!",

            "con.faq.question1": "Какие браузеры поддерживаются Cyberfox Guard?",
            "con.faq.text1": "Cyberfox Guard поддерживает специальную сборку Chrome для безопасности. Пожалуйста, свяжитесь с нами для получения поддержки.",
            "con.faq.question2": "Как Cyberfox Guard защищает мои данные?",
            "con.faq.text2": "Cyberfox Guard использует комбинацию шифрования и безопасных протоколов для защиты ваших данных.",
            "con.faq.question3": "Сколько учетных записей я могу добавить на эту платформу?",
            "con.faq.text3": "Нет ограничений на количество учетных записей и паролей, которые вы можете хранить и делиться ими с вашими коллегами, используя CyberFox Guard.",
            "con.faq.question4": "Как я могу получить поддержку?",
            "con.faq.text4": "Вы можете связаться с нами по электронной почте на hello@cyberfoxguard.com",


            "con.headline5": "Как начать?",
            "con.text5": "Установка проста и быстра. Просто следуйте приведенным ниже шагам.",


            //general
            "misc.more": "и многое другое...",
            "misc.privacy": "Политика конфиденциальности",
            "misc.terms": "Условия обслуживания",
            "misc.downloads": "Загрузки и установки",
            "misc.extension": "Расширение",
            "misc.app": "Приложение",
            "misc.appstore": "App Store",
            "misc.playstore": "Play Store",
            "misc.contact": "Связаться с нами",


            //contact form

            "con.contact.title": "Связаться с нами",
            "con.contact.text": "Если у вас есть какие-либо вопросы, пожалуйста, свяжитесь с нами.",
            "con.contact.name": "Имя",
            "con.placeholder.name": "Ваше имя",
            "con.contact.email": "Электронная почта",
            "con.placeholder.email": "Ваш адрес электронной почты",
            "con.contact.phone": "Телефон",
            "con.placeholder.phone": "Ваш телефон",
            "con.contact.message": "Сообщение",
            "con.placeholder.message": "Ваше сообщение",
            "con.contact.send": "Отправить",
            "con.contact.success": "Ваше сообщение было успешно отправлено.",
            "con.contact.error": "При отправке вашего сообщения произошла ошибка. Пожалуйста, попробуйте еще раз позже.",
            //Are you human?
            "con.contact.human": "Вы человек?",
            "con.contact.human.error": "Пожалуйста, подтвердите, что вы человек.",
            "con.contact.human.success": "Спасибо за подтверждение, что вы человек.",

            "con.contact.human.op0": "Выберите ответ",
            "con.contact.human.op1": "Нет, я не человек!",
            "con.contact.human.op2": "Что такое человек?",
            "con.contact.human.op3": "Хотел бы я быть :)",
            "con.contact.human.op4": "На самом деле, я человек!",
            "con.contact.human.op5": "Может быть, когда-нибудь...",


            //buttons
            "btn.download": "Скачать",
            "btn.contact": "Связаться с отделом продаж",
            "btn.learn": "Узнать больше",
            "btn.close": "Закрыть",
            "btn.open": "Открыть",
            "btn.cancel": "Отменить",
            "btn.send": "Отправить",
            "btn.send.another": "Отправить еще",

            //footer
            "footer.copyright": "Copyright © 2023 CyberFoxGuard. All rights reserved.",
            "footer.privacy": "Privacy Policy",
            "footer.terms": "Terms of Service",


            //Pricing
            "price.subscription": "Подписка",
            "price.monthly": "ежемесячно на пользователя",
            "price.yearly": "ежегодно на пользователя",

            //  Basic Subscription
            "price.block1.type": "Базовый",
            "price.block1.desk": "Базовый план подписки включает все будущие обновления с ограниченным объемом памяти.",
            "price.block1.bull1": "Неограниченные учетные записи и пароли",
            "price.block1.bull2": "Ограниченная история и журналы",
            "price.block1.bull3": "Обновления (функции и виджеты)",
            "price.block1.bull4": "Расширенные статистические данные",
            "price.block1.bull5": "Резервное копирование в облаке",

            //  Pro Subscription
            "price.block2.type": "Профессиональный",
            "price.block2.desk": "План подписки Pro включает все функции и увеличение вашей безопасности вместе с Pro Extension.",
            "price.block2.bull1": "Неограниченные учетные записи и пароли",
            "price.block2.bull2": "Неограниченная история и журналы",
            "price.block2.bull3": "Обновления (функции и виджеты)",
            "price.block2.bull4": "Расширенные статистические данные",
            "price.block2.bull5": "Резервное копирование в облаке",



        },
    },
});